import { useEffect, useState } from "react";
import { ordersAPI } from "@/services/api";
import { BookOpen, ShoppingCart } from "lucide-react";
import { CardGrid, LoadingState, PageHeader, PageShell, QuickAction, SectionCard, StatCard } from "@/components/app/page";

export default function BuyerDashboard({ user }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const response = await ordersAPI.list();
      setOrders(response.data);
    } catch (error) {
      console.error("Error loading orders", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingState />;

  return (
    <PageShell data-testid="buyer-dashboard">
      <PageHeader title="Tableau de bord acheteur" description={`Bienvenue, ${user.full_name}`} />

      <CardGrid className="xl:grid-cols-2">
        <StatCard title="Mes commandes" value={orders.length} icon={ShoppingCart} tone="blue" testId="total-orders" />
      </CardGrid>

      <SectionCard title="Actions rapides">
        <div className="space-y-3">
          <QuickAction
            href="/catalogue"
            icon={BookOpen}
            title="Parcourir le catalogue"
            description="découvrir les produits ARTICO"
            testId="quick-action-browse-catalogue"
          />
          <QuickAction
            href="/orders"
            icon={ShoppingCart}
            title="Mes commandes"
            description={`${orders.length} commande(s)`}
            testId="quick-action-view-orders"
          />
        </div>
      </SectionCard>
    </PageShell>
  );
}
